import React from 'react'

import { cn } from 'utils'

import BudgetComparisonBar, {
  type BudgetComparisonBarProps,
} from '../BudgetComparisonBar/BudgetComparisonBar'

interface BudgetComparisonSectionProps extends BudgetComparisonBarProps {
  title: string;
  description: string | React.ReactNode;
  children?: React.ReactNode;
}

const BudgetComparisonSection: React.FC<BudgetComparisonSectionProps> = ({
  title,
  description,
  children,
  ...props
}) => {
  return (
    <div className='flex flex-col'>
      <h2
        className={cn('text-gray-800', {
          'body-sm mb-1': props.condensed,
          'heading-sm mb-2': !props.condensed,
        })}
      >
        {title}
      </h2>
      {!props.condensed && (
        <p className='body text-gray-500 mb-4'>{description}</p>
      )}
      <BudgetComparisonBar {...props} />
      {!props.condensed && children}
    </div>
  )
}

export default BudgetComparisonSection
